module.exports = __webpack_public_path__ + "media/images/sp/specials/common/spot_chidorigahama-8d46c1081eef1fb03c697d2f63b1e827.jpg";